import { useEffect, useState } from 'react'
import { Button } from '@bm-js/atlascloud-ui'
import Input from './Input'
import { ChangeEvent, UserBM } from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

export type UserInput = Omit<
  UserBM,
  | '_id'
  | 'hasCreatedPassword'
  | 'blocked'
  | 'numberOfFailedLogins'
  | 'customerId'
  | 'permissionsV2'
> & { _id?: string }

type Props = {
  data?: UserInput
  handleSubmit: (
    data: UserInput,
    success: () => void,
    error: () => void
  ) => void
  closePopup: () => void
}

const UserForm = ({ data, handleSubmit, closePopup }: Props) => {
  const { tr } = useTr()
  //Static
  const initialUser: UserInput = {
    email: '',
    fullName: '',
    phone: '',
  }

  //States
  const [formData, setFormData] = useState(initialUser)
  const [loading, setLoading] = useState(false)

  //Functions
  const handleChange = (e: ChangeEvent) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  //Effects
  useEffect(() => {
    // eslint-disable-next-line
    if (data) setFormData(data)
  }, [data])

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        setLoading(true)
        handleSubmit(
          formData,
          () => {
            setLoading(false)
            setFormData(initialUser)
          },
          () => {
            setLoading(false)
          }
        )
      }}
    >
      <h1 className='m0 primblue mbottom1'>{tr(TrKey.usersCreateUser)}</h1>
      <Input
        label={tr(TrKey.name)}
        desc={tr(TrKey.usersFullNameDescription)}
        required
        disabled={loading}
        type='text'
        value={formData.fullName}
        name='fullName'
        placeholder={tr(TrKey.usersFullNamePlaceholder)}
        onChange={handleChange}
      />
      <Input
        label={tr(TrKey.emailAddress)}
        desc={tr(TrKey.usersEmailDescription)}
        required
        disabled={loading}
        type='text'
        value={formData.email}
        name='email'
        placeholder='example@mail.com'
        onChange={handleChange}
      />
      <div className='jce gap1 flex'>
        <Button type='submit' disabled={loading}>
          {loading ? tr(TrKey.saving) : tr(TrKey.save)}
        </Button>
        <Button danger disabled={loading} onClick={closePopup}>
          {tr(TrKey.cancel)}
        </Button>
      </div>
    </form>
  )
}

export default UserForm
